/**
 * Genre name → URL slug. Same logic on both sides (client + server) so the
 * mega-menu, the listing pages, and the `/genre/[slug]` resolver all agree.
 *
 * Edge cases that bit the first version:
 *   - "R&B" used to become "rand" because `replace(/&/g, 'and')` produced
 *     "rb→rand" with no separator. We now wrap `&` in hyphens.
 *   - "Folk/Country" used to become "folkcountry" because `[^\w\s-]` stripped
 *     the slash with nothing in its place. Replace `/` with `-` first.
 *   - Multiple-hyphen / leading-hyphen artefacts are collapsed at the end.
 */
export function slugifyGenre(name: string | null | undefined): string {
    return String(name || '')
        .toLowerCase()
        .replace(/&/g, '-and-')
        .replace(/\//g, '-')
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')
}
